var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconChevronRightSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 6,
  viewBox: "0 0 300 300"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M120 236.9a8.8 8.8 0 0 1-5.5-1.9 8.9 8.9 0 0 1-1.6-12.6l55.7-71.5-55.8-73.4a9 9 0 0 1 14.4-10.9l64.2 84.4-64.3 82.4a8.9 8.9 0 0 1-7.1 3.5"
})));
export default SvgIconChevronRightSmall;